export default [
  {
    path: '/vocab-topic',
    component: () => import('./views/Index'),
    name: 'vocab-topic',
    redirect: { name: 'vocab-topic-list' },
    children: [
      {
        path: '',
        name: 'vocab-topic-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'content',
        },
      },
      {
        path: 'detail/:topic_id',
        name: 'vocab-topic-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'content',
        },
      },
    ],
  },
]
